import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Text from '../Text';
import { TextElements } from '../Text/types';
import { Wrapper } from './styles';
export const DefaultLabelComponent = (props) => (_jsx(Text, Object.assign({ el: TextElements.Label }, props)));
const TextArea = (_a) => {
    var _b;
    var { className, resizable = true } = _a, props = __rest(_a, ["className", "resizable"]);
    // Our "label inside the border" design doesn't work with textareas
    // because the text overlaps the label while the user types,
    // because browsers don't respect padding in textareas as they grow
    const LabelComponent = (_b = props.LabelComponent) !== null && _b !== void 0 ? _b : (props.label ? DefaultLabelComponent : undefined);
    return (_jsx(Wrapper, Object.assign({ LabelComponent: LabelComponent }, props, { UNSAFE_showFocus: props.$UNSAFE_showFocus, UNSAFE_hasBlurred: props.$UNSAFE_hasBlurred, customInputIsTextArea: true, CustomInputProps: { $resizable: resizable, className } })));
};
export default TextArea;
//# sourceMappingURL=index.js.map